import React from "react";
import { constants } from "@/constants";
import { useTranslation } from "react-i18next";
import { Widget } from "@typeform/embed-react";
import { FormCard } from "@/components/FormCard";

export const ChannelRequestForm = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <div className="w-full pt-6 pr-6 pl-8">
        <h1 className="mb-4 text-2xl font-semibold text-foreground">
          {t("channelRequest.title")}
        </h1>
      </div>
      <div className="px-8 pt-8">
        <FormCard
          title={t("channelRequest.cardTitle")}
          description={t("channelRequest.cardDescription")}
          className="w-full max-w-5xl"
        >
          {constants?.TYPEFORM_CHANNEL_REQUEST_ID && (
            <div className="relative my-10 h-[550px] min-h-[450px] w-full">
              <Widget
                id={constants.TYPEFORM_CHANNEL_REQUEST_ID}
                className="h-full w-full"
              />
            </div>
          )}
        </FormCard>
      </div>
    </div>
  );
};
